import { observable } from "@legendapp/state";

/**
 * Host-org metadata (name + logo) for boards the viewer doesn't belong to.
 * Populated by the snapshot hydrator and read by `TopBar`'s
 * `ReadOnlyOrgHeader` so the top-left chip shows the **board owner**, not
 * the viewer's `activeOrganization$`. This is snapshot-only data that
 * doesn't fit `organizations$` (which is scoped to orgs the viewer is a
 * member of).
 *
 * Keyed by `boardId` so a viewer browsing multiple read-only boards in
 * the same tab keeps each board's host-org chip correct.
 */
export const hostOrgs$ = observable<
  Record<string, { name: string; logo: string | null }>
>({});
